exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".retry__main {\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  padding: 2px 20px;\n  border-radius: 15px;\n  background: #808080d9;\n  font-weight: 600;\n  color: rgb(255, 255, 255);\n  -webkit-box-shadow: 0px 0px 35px #fff;\n          box-shadow: 0px 0px 35px #fff;\n}\n\n.retry_error-icon{\n  position: absolute;\n    color: red;\n    font-size: 25px;\n    right: -44px;\n    font-weight: 500;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Retry.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Retry.css
// module chunks = 120